import React, { useState, useEffect, useCallback } from "react";
import ButtonSpinner from "../../ButtonSpinner";
import { useNavigate } from "react-router-dom";
import useAuthentication from "../Controller/useAuthentication.controller";
import "./Auth.css";
export default function Auth() {
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [ui, setUi] = useState({
    isLogin: true,
    loading: false,
    error: "",
    success: "",
    showPassword: false,
    showReset: false,
    resetEmail: ""
  });
  // Force showReset to false on mount
  useEffect(() => {
    setUi((u) => ({ ...u, showReset: false }));
    }, []);
  useEffect(() => {
    }, [ui]);
  // DEBUG: Log modal state
  useEffect(() => {
    }, [ui.showReset]);
  // Escape key closes modal
  useEffect(() => {
    if (!ui.showReset) return;
    const handler = (e) => {
      if (e.key === 'Escape') setUi((u) => ({ ...u, showReset: false }));
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [ui.showReset]);
  const navigate = useNavigate();
  const { handleSubmit, handleGoogleSignIn } = useAuthentication();
  // Google sign-in init
  useEffect(() => {
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (!googleClientId) return;

    const renderGoogleButton = () => {
      if (window.google?.accounts?.id) {
        window.google.accounts.id.initialize({
          client_id: googleClientId,
          callback: (res) =>
            handleGoogleSignIn({
              setError: (msg) => setUi((u) => ({ ...u, error: msg })),
              setSuccess: (msg) => setUi((u) => ({ ...u, success: msg })),
              setLoading: (val) => setUi((u) => ({ ...u, loading: val })),
              navigate,
              credential: res.credential
            })
        });
        window.google.accounts.id.renderButton(
          document.getElementById("google-signin-btn"),
          { theme: "outline", size: "large" }
        );
      }
    };
    if (!window.google) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = renderGoogleButton;
      document.body.appendChild(script);
    } else renderGoogleButton();
  }, [handleGoogleSignIn, navigate]);
  // Handlers
  const onChange = useCallback(
    (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value })),
    []
  );
  const onSubmit = useCallback(
    (e) =>
      handleSubmit({
        e,
        ...form,
        isLogin: ui.isLogin,
        setError: (msg) => setUi((u) => ({ ...u, error: msg })),
        setSuccess: (msg) => setUi((u) => ({ ...u, success: msg })),
        setLoading: (val) => setUi((u) => ({ ...u, loading: val })),
        setIsLogin: (val) => setUi((u) => ({ ...u, isLogin: val }))
      }),
    [form, ui.isLogin, handleSubmit]
  );
  return (
    <main
      className="auth-container"
      style={{ "--bg-image": 'url("/loginImage.jpeg")' }}
    >
      {/* Left Panel */}
      <section className="auth-card">
        <header className="logo-wrapper">
          <img src="/IntelliMe.png" alt="IntelliMe logo" className="app-logo" />
        </header>
        <h2>{ui.isLogin ? "Welcome Back" : "Create Account"}</h2>
        <form onSubmit={onSubmit} className="auth-form">
          {!ui.isLogin && (
            <input
              id="name"
              name="name"
              type="text"
              placeholder="Full Name"
              value={form.name}
              onChange={onChange}
              className="auth-input"
              autoComplete="name"
            />
          )}
          <input
            id="email"
            name="email"
            type="email"
            placeholder="Email Address"
            value={form.email}
            onChange={onChange}
            className="auth-input"
            autoComplete="email"
          />
          <div className="password-wrapper">
            <input
              id="password"
              name="password"
              type={ui.showPassword ? "text" : "password"}
              placeholder="Password (min 6 characters)"
              value={form.password}
              onChange={onChange}
              className="auth-input"
              autoComplete="current-password"
            />
            <button
              type="button"
              className="show-hide-btn"
              onClick={() =>
                setUi((u) => ({ ...u, showPassword: !u.showPassword }))
              }
              aria-label={ui.showPassword ? "Hide password" : "Show password"}
            >
              {ui.showPassword ? (
                // Open eye SVG
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C3.5 7 8 4 12 4C16 4 20.5 7 23 12C20.5 17 16 20 12 20C8 20 3.5 17 1 12Z"
                    stroke="#6c63ff"
                    strokeWidth="2"
                    fill="none"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#6c63ff"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              ) : (
                // Closed eye SVG
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C3.5 7 8 4 12 4C16 4 20.5 7 23 12C21.5 15 18.5 18 15 19.5"
                    stroke="#6c63ff"
                    strokeWidth="2"
                    fill="none"
                  />
                  <path
                    d="M3 3L21 21"
                    stroke="#6c63ff"
                    strokeWidth="2"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#6c63ff"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              )}
            </button>
          </div>
          <button type="submit" disabled={ui.loading} className="auth-btn">
            {ui.loading ? <ButtonSpinner /> : ui.isLogin ? "Login" : "Sign Up"}
          </button>
        </form>
        <nav className="auth-links">
          {/* {ui.isLogin && (
            <button
              type="button"
              className="forgot-btn"
              onClick={() => setUi((u) => ({ ...u, showReset: true }))}
            >
              Forgot Password?
            </button>
          )} */}
          {/* <button
            type="button"
            className="toggle-link"
            onClick={() =>
              setUi((u) => ({
                ...u,
                isLogin: !u.isLogin,
                error: "",
                success: ""
              }))
            }
          >
            {ui.isLogin
              ? "Don't have an account? Sign up"
              : "Already have an account? Login"}
          </button> */}
        </nav>
        {ui.error && <div className="auth-error">{ui.error}</div>}
        {ui.success && <div className="auth-success">{ui.success}</div>}
        {/* <div className="divider">or</div>
        <div id="google-signin-btn" style={{ marginBottom: 16 }}></div>
        {ui.showReset && (
            ReactDOM.createPortal(
              <div className="reset-modal">
                <form onSubmit={onPasswordReset} className="reset-form">
                  <h3>Reset Password</h3>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={ui.resetEmail}
                    onChange={(e) =>
                      setUi((u) => ({ ...u, resetEmail: e.target.value }))
                    }
                    className="auth-input"
                    autoComplete="email"
                  />
                  <button type="submit" className="auth-btn" disabled={ui.loading}>
                    {ui.loading ? <ButtonSpinner /> : "Send Reset Email"}
                  </button>
                  <button
                    type="button"
                    className="close-btn"
                    onClick={() => setUi((u) => ({ ...u, showReset: false }))}
                  >
                    Cancel
                  </button>
                </form>
              </div>,
              document.body
            )
        )} */}
      </section>
      {/* Right Background/Info */}
      <aside className="auth-visuals">
        <div className="social-info">
          {/* <h3>Connect, Share, Interact!</h3>
          <p>
            Join the community and start making new friends, sharing moments,
            and interacting with others.
          </p> */}
        </div>
      </aside>
    </main>
  );
}
